import { Component, OnInit } from '@angular/core';
import {FirebaseService} from "../../shared/service/firebase.service";
import {FirebaseValue} from "../../shared/enum/firebase-event.enum";
@Component({
  selector: 'app-privacy-modal',
  templateUrl: './privacy-modal.component.html',
  styleUrls: ['./privacy-modal.component.scss']
})
export class PrivacyModalComponent  implements OnInit {

  constructor(private firebaseService: FirebaseService) { }

  ngOnInit() {

    this.firebaseService.trackPageNameEvent(FirebaseValue.PRIVACY_MODAL);
  }

}
